// Match Lineup — the half-pitch surface (design handoff, ported 1:1).
//
// ONE half-pitch drawing for both teams: keeper end at the bottom, halfway
// line at the top. The viewBox matches the 100:135 container ratio
// (aspect-ratio 0.7407), so the two arcs are drawn as ellipses — a real
// half-pitch is wider than tall, the vertical lineup frame stylises it, same
// as every lineup graphic. Navy gradient + mowing stripes + 12px radius are
// the handoff values verbatim.

import React from "react";

const LINE = "rgba(255,255,255,0.58)";
const LW = 1.15;

const PitchLines = () => (
  <svg
    viewBox="0 0 100 135"
    preserveAspectRatio="none"
    fill="none"
    style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      pointerEvents: "none",
    }}
  >
    <rect x={3} y={3} width={94} height={129} stroke={LINE} strokeWidth={LW} fill="none" />
    <rect x={22.2} y={106} width={55.6} height={26} stroke={LINE} strokeWidth={LW} fill="none" />
    <rect x={37.4} y={123} width={25.2} height={9} stroke={LINE} strokeWidth={LW} fill="none" />
    <circle cx={50} cy={115} r={1.1} fill={LINE} />
    <path d="M41.1 106 A12.65 12.65 0 0 1 58.9 106" stroke={LINE} strokeWidth={LW} fill="none" />
    <path d="M37.35 3 A12.65 12.65 0 0 0 62.65 3" stroke={LINE} strokeWidth={LW} fill="none" />
    <circle cx={50} cy={3} r={1} fill={LINE} />
    <rect x={44.95} y={132} width={10.1} height={2.6} stroke={LINE} strokeWidth={LW} fill="none" />
    <path d="M3 129.4 A2.6 2.6 0 0 0 5.6 132" stroke={LINE} strokeWidth={LW} fill="none" />
    <path d="M94.4 132 A2.6 2.6 0 0 0 97 129.4" stroke={LINE} strokeWidth={LW} fill="none" />
  </svg>
);

// `dimBottom` paints the mobile bottom gradient (handoff sub-scene L12.3:
// the sheet's scrim never hides the tapped node). `style`/`flex` let the
// container drive the 58/42 split at ≥1440.
const Pitch = ({ children, dimBottom = false, style }) => (
  <div
    style={{
      position: "relative",
      minWidth: 0,
      width: "100%",
      aspectRatio: "0.7407",
      borderRadius: 12,
      overflow: "hidden",
      background:
        "linear-gradient(175deg,#0B2137 0%,#123353 62%,#0E2A44 100%)",
      border: "1px solid #0B2137",
      ...style,
    }}
  >
    {/* mowing stripes */}
    <div
      style={{
        position: "absolute",
        inset: 0,
        background:
          "repeating-linear-gradient(180deg,rgba(255,255,255,0.028) 0 8%,rgba(255,255,255,0) 8% 16%)",
      }}
    />
    <PitchLines />
    {children}
    {dimBottom && (
      <div
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          height: "52%",
          pointerEvents: "none",
          background:
            "linear-gradient(180deg,rgba(2,6,23,0) 0%,rgba(2,6,23,0.45) 60%)",
        }}
      />
    )}
  </div>
);

export default Pitch;
